<template>
  <div class="navbar-top">
    <div class="row mx-0">
      <div class="col-lg-5 pt-3 d-none d-sm-none d-md-none d-lg-block">
        <a href="https://www.mekong.travel" target="_blank" rel="noopener noreferrer"><img :src="logoText" /></a>
      </div>
      <div class="col-2 col-md-2 col-lg-2 text-left text-md-center text-lg-center pt-4">
        <router-link to="/"><img :src="logo" class="logo" /></router-link>
      </div>
      <div class="col-10 col-md-10 col-lg-5 pt-3">
        <div class="hastag">
          <ul class="list-hastag">
            <li>#MEKONGMEMORIES</li>
            <li>#TRAVELTOMORROW</li>
          </ul>
        </div>
        <div class="menu">
          <ul class="list-menu">
            <li>
              <router-link to="/how-to-participate">HOW TO PARTICIPATE</router-link>
            </li>
            <li>
              <router-link to="/prizes">PRIZES</router-link>
            </li>
            <li>
              <router-link to="/terms">TERMS &amp; CONDITIONS</router-link>
            </li>
            <li>
              <router-link to="/about">ABOUT</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoText from "@/assets/images/logotext.png";
import logo from "@/assets/images/logo.png";
export default {
  name: "navbar-top",
  data() {
    return {
      logoText: logoText,
      logo: logo
    };
  }
};
</script>

<style lang="scss">
.navbar-top {
  border-bottom: 13px #da006a solid;
  padding-bottom: 40px;
  .hastag {
    padding-bottom: 60px;

    .list-hastag {
      list-style: none;
      padding: 0;

      li {
        text-align: right;
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
      }
    }
  }

  .menu {
    .list-menu {
      list-style: none;
      padding: 0;
      display: flex;
      justify-content: flex-end;

      li {
        padding: 0 20px;

        a {
          text-decoration: black;
          color: black;
          font-size: 18px;
          font-weight: lighter;

          &.router-link-exact-active {
            color: #da006a;
          }
        }

        &:last-child {
          padding-right: 0;
        }
      }
    }
  }

  @media (max-width: 1300px) {
    .menu {
      .list-menu {
        list-style: none;
        padding: 0;
        display: flex;
        justify-content: flex-end;

        li {
          padding: 0 10px;

          a {
            text-decoration: black;
            color: black;
            font-size: 14px;
            font-weight: lighter;
          }

          &:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }

  @media (max-width: 1023.98px) {
      padding-bottom: 0;
    .logo {
      width: 80px;
    }

    .hastag {
      padding-bottom: 20px;

      .list-hastag {
        list-style: none;
        padding: 0;

        li {
          text-align: right;
          font-size: 16px;
          font-weight: bold;
          line-height: 16px;
        }
      }
    }

    .menu {
      .list-menu {
        li {
          padding: 0 15px;

          a {
            font-size: 14px;
          }

          &:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }

  @media (max-width: 767.98px) {
    padding-bottom: 0;
    .logo {
      width: 80px;
    }

    .hastag {
      padding-bottom: 20px;

      .list-hastag {
        list-style: none;
        padding: 0;

        li {
          text-align: right;
          font-size: 16px;
          font-weight: bold;
          line-height: 16px;
        }
      }
    }

    .menu {
      .list-menu {
        list-style: none;
        padding: 0;
        display: flex;
        justify-content: flex-end;

        li {
          padding: 0 15px;

          a {
            text-decoration: black;
            color: black;
            font-size: 14px;
            font-weight: lighter;
          }

          &:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }

  @media (max-width: 575.98px) {
    padding-bottom: 10px;
    .menu {
      display: none;
    }
  }
}
</style>